import { render, staticRenderFns } from "./Modal1.vue?vue&type=template&id=772cede0&scoped=true&"
import script from "./Modal1.vue?vue&type=script&lang=js&"
export * from "./Modal1.vue?vue&type=script&lang=js&"
import style0 from "./Modal1.vue?vue&type=style&index=0&id=772cede0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772cede0",
  null
  
)

export default component.exports